import FetchUtils from '../utils/fetch.utils';

export default class InstallmentsService {
  static BASE_URL = `${process.env.PREACT_APP_API_DOMAIN_INSTALLMENTS}/api/credits/installments`;

  static getInstallments = async params => {
    return FetchUtils.get(
      InstallmentsService.BASE_URL + FetchUtils.getQueryParams(params),
    );
  };

  static getInstallmentById = async (id, organizationCode, amount) => {
    return FetchUtils.get(
      `${InstallmentsService.BASE_URL}/${id}?organizationCode=${organizationCode}&amount=${amount}`,
    );
  };
}
